import { init } from "@nosto/preact"
import { config as configV1 } from "./config.v1.js"
import { config as configV2 } from "./config.v2.js"

import "./styles/index.css"

const currentVersion = "v2"
const initConfig = currentVersion == "v1" ? configV1 : configV2;

init(initConfig)
